import types from './types';

export const setCookieSettingsOpen = (open) => ({
  open,
  type: types.SET_COOKIES_SETTINGS_OPEN,
});
